export default {
  featuredExperiences: '精選體驗',
  searchAllExperiences: '搜尋所有體驗',
  searchAll: '搜尋全部',
  groupSize: '團體人數',
  eventSize: '活動人數',
  upTo: '最多',
  whatWeDo: '我們將會做什麼',
  hostedBy: '由...主辦',
  whatsIncluded: '包含內容',
  avail: '可預約情況',
  whereWeAre: '我們將會在哪裡',
  experienceCalendar: '體驗日曆',
  experienceCancelled: '體驗已取消',
  experienceStartingPrice: '起價 {{price}}',
  experienceTotalPrice: '總價 {{price}}',
  at: '於',
  viewPrivateSessAvailability: '查看私人場次可預約情況',
  selectDuration: '選擇時長',
  selectStartTime: '選擇開始時間',
  selectSession: '選擇場次',
  noAvailability: '無可預約時間',
  select: '選擇',
  slotsLeft: '剩餘 {{remainSlots}} 個名額',
  slotLeft: '剩餘 {{remainSlots}} 個名額',
  bookExperience: '預訂體驗',
  book: '預訂',
  apply: '套用',
  maxPartySizes: '每組最多 {{maxGroupSize}} 人',
  maxPartySize: '每組最多 {{maxGroupSize}} 人',
  selectSessionValidation: '請選擇場次',
  selectParticipantValidation: '請選擇參與者',
  selectDateValidation: '請選擇日期',
  reminders: '提醒事項',
  seeOtherDates: '查看其他日期',
  location: '地點',
  about: '關於',
  soldOut: '已售罄',
  reviews: '評論',
  reviewSingular: '則評論',
  reviewPlural: '則評論',
  dateOfExperience: '體驗日期',
  readLess: '收起',
  readMore: '閱讀更多',
  seeMore: '查看更多',
  details: '詳細資訊',
  theFollowingVideoDoesNotContainAnyAudio: '以下影片無聲音',
  by: '由',
  amenities: '設施',
};
